module.exports = __webpack_public_path__ + "img/Ultra-Flexible-1536x958.jpg.31c01f53.webp";